var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 242,
    viewBox: "0 0 134 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78307 91.983L1 69.5802C1 46.3804 11.6497 22.6504 17.5 17.2084C40.2866 -3.98836 84.6802 -7.41983 117 17.2084C124.823 23.1696 133 57.58 133 71.5802L131.235 91.9966C130.03 91.062 128.609 90.3713 126.948 89.973C126.983 88.6252 127 87.2629 127 85.8864C127 39.5039 107.169 14.5801 67 14.5801C26.8312 14.5801 7 39.5039 7 85.8864C7 87.2629 7.01747 88.6252 7.05241 89.973C5.39879 90.3694 3.98382 91.0553 2.78307 91.983Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8539 126.761C10.5054 136.213 10.2052 153.65 10.9191 185.806C10.9195 186.035 10.9247 186.266 10.9346 186.501C10.9521 187.278 10.9701 188.064 10.9887 188.858L11.1684 188.797C12.0019 194.109 14.9294 200.834 20.0345 210.108C17.6004 221.39 19.8195 230.559 27.2606 235.832C28.1428 236.457 29.3664 236.122 29.9344 235.202C30.8008 233.799 31.6298 232.453 32.4214 231.163C34.2924 234.233 36.2885 237.487 38.4105 240.94C38.9776 241.862 40.2074 242.207 41.1102 241.609C58.5197 230.077 58.5286 204.697 44 173.989V155.975C30.6742 150.76 20.9716 140.662 14.8539 126.761Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6566 8.49993C-7.44105 8.49993 3.65115 67.5002 2.13861 77L1.63443 80C1.63481 71.0014 -16.0121 3 64.6566 3C146.5 3 132.721 60 132.721 80L132.217 79C128.184 70.5001 144.343 8.49993 64.6566 8.49993Z",
    fill: "#D3D3D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5181 21.3955C81.8291 31.0802 51.1402 30.4479 34.7159 21.3955C27.9646 17.6745 41.6018 4.58019 67.4303 4.5802C82.5341 4.58021 106.576 15.804 97.5181 21.3955Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairV);
export default __webpack_public_path__ + "static/media/Hair V.637ebcd914c02cd029632fdd3c572bb1.svg";
export { ForwardRef as ReactComponent };